<script>
import CountryCodeSelector from "vue-country-code-selector"

export default {
  name: "country-code-selector",
  extends: CountryCodeSelector,
  watch: {
    countryCode() {
      this.currentCode = this.countryCode
    }
  },
  methods: {
    handleShowAndFlyTo() {
      let n = this
      this.hideSubMenu = !this.hideSubMenu
      if (this.hideSubMenu) {
        this.$nextTick(() => this.changeInputTip())
        document.addEventListener("click", function() {
          n.hideSubMenu = !1
        })
        setTimeout(function() {
          document
            .querySelector(".highlight")
            .scrollIntoView({ block: "center", behavior: "smooth" })
        }, 100)
      }
    },
    changeInputTip() {
      this.$el.querySelector(".search-input").setAttribute("placeholder", "搜索国家/地区")
    }
  }
}
</script>
